<template>
    <div class="label-filter">

        <b-form-checkbox-group v-model="selected"
             name="label-filter"
             switches
             stacked
             size="lg"
             @input="refreshData()">
            <b-form-checkbox v-for="(option,index) in posts"
                             :key="index"
                             :value="option.id"
                             :style="{ color: option.color_bg }">
                {{option.name}}<div class="label-bg" v-bind:style="{backgroundColor: option.color_bg }"></div>
            </b-form-checkbox>
        </b-form-checkbox-group>
    
        <hr>
    
        <b-form-checkbox
            v-model="filter"
            value="user_loan_equip"
            @input="filterData()"
        >
            Moje půjčky
        </b-form-checkbox>
        <b-form-checkbox
            v-model="filter"
            value="all_loan_equip"
            @input="filterData()"
        >
            Všechny půjčky
        </b-form-checkbox>
        <b-form-checkbox
            v-model="filter"
            value="user_reserve_equip"
            @input="filterData()"
        >
            Moje rezervace
        </b-form-checkbox>
        <b-form-checkbox
            v-model="filter"
            value="all_reserve_equip"
            @input="filterData()"
        >
            Všechny rezervace
        </b-form-checkbox>
        
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "label-filtration",
        data() {
            return {
                posts: [],
                selected: [],
                filter: false,
    
            }
        },
        methods: {
            async loadData() {
                try {
                    const response_data = await axios({
                        url: process.env.VUE_APP_SERVER+'labels/list.php',
                        headers: { 'content-type': 'application/x-www-form-urlencoded' },
                        method: 'GET'
                    });

                    this.posts = response_data.data.records;

                } catch (error) {
                    console.log("error", error);
                    this.$store.dispatch('logout');
                }

            },
            refreshData() {
                this.$emit('loadLabeledData', this.selected);
            },
            filterData() {
                this.$emit('filterData', this.filter);
            },

        },
        created() {
            this.loadData();
        }
    }
</script>

<style lang="scss" scoped>
    .label-filter {
        padding: 0 10px;
        li {
            padding: 0 10px;
        }
    }

</style>

<style lang="scss" >
    .label-filter {
        .custom-control-label {
            width: 100%;
            text-align: right;
        }
        .custom-control {
            margin-bottom: 5px;
        }
        .label-bg {
            width: 5px;
            height: 15px;
            display: inline-block;
            margin-left: 5px;
        }
        label {
            white-space: nowrap;
        }
    }
</style>
